<ng-container [formGroup]="trafficDeviationInformationGroup">
  <fieldset>
    <div class="form-group">
      <app-form-select-with-errors
        [label]="'Template'"
        [options$]="templateOptions$"
        [control]="templateOptions"
        [showValidation]="false">
      </app-form-select-with-errors>
    </div>
  </fieldset>

  <fieldset class="textarea-with-chips-wrapper">
    <div class="form-group">
      <app-textarea-with-chips
        [options]="{
            control: trafficDeviationInformationGroup.controls.summary,
            id: 'summary',
            label: 'Summarized',
            caption: 'A short message shown in journey planner search results, on board the vehicle, and at stops.'
        }"
        [editable]="!(selectedTemplate$ | async) && 'plaintext-only'"
        [invalid]="(trafficDeviationInformationGroup.controls.summary.touched || trafficDeviationInformationGroup.controls.summary.dirty) && trafficDeviationInformationGroup.controls.summary.invalid">
      </app-textarea-with-chips>

      @if (trafficDeviationInformationGroup.controls.summary.touched
        || trafficDeviationInformationGroup.controls.summary.dirty) {
        <app-validation-message
          [control]="trafficDeviationInformationGroup.controls.summary"
          >
        </app-validation-message>
      }
    </div>
  </fieldset>

  <fieldset class="textarea-with-chips-wrapper">
    <div class="form-group">
      <div style="margin-bottom: 6px">
        <app-textarea-with-chips
          [options]="{
              control: trafficDeviationInformationGroup.controls.header,
              id: 'header',
              label: 'Detailed',
              caption: 'A message shown in the traffic view in the app and on the web. Both a heading and a message are required.',
              asTextInput: true
          }"
          [editable]="!(selectedTemplate$ | async) && 'plaintext-only'"
          [invalid]="(trafficDeviationInformationGroup.controls.header.touched || trafficDeviationInformationGroup.controls.header.dirty) && trafficDeviationInformationGroup.controls.header.invalid">
        </app-textarea-with-chips>
        @if (
          (trafficDeviationInformationGroup.controls.header.touched
          || trafficDeviationInformationGroup.controls.header.dirty)
          && { status: trafficDeviationInformationGroup.controls.header.statusChanges | async}
        ) {
          <app-validation-message
            class="header-validation-message"
            [control]="trafficDeviationInformationGroup.controls.header"
            >
          </app-validation-message>
        }
      </div>

      <app-textarea-with-chips
        [options]="{
            control: trafficDeviationInformationGroup.controls.content,
            id: 'content'
        }"
        [editable]="!(selectedTemplate$ | async) && 'plaintext-only'"
        [invalid]="(trafficDeviationInformationGroup.controls.content.touched || trafficDeviationInformationGroup.controls.content.dirty) && trafficDeviationInformationGroup.controls.content.invalid">
      </app-textarea-with-chips>
      @if (
        (trafficDeviationInformationGroup.controls.content.touched
        || trafficDeviationInformationGroup.controls.content.dirty)
        && { status: trafficDeviationInformationGroup.controls.content.statusChanges | async}) {
        <app-validation-message
          [control]="trafficDeviationInformationGroup.controls.content"
          >
        </app-validation-message>
      }

      <app-validation-message [control]="trafficDeviationInformationGroup.controls.allChipsHasValue"></app-validation-message>
    </div>
  </fieldset>

  <app-information-details [requiredCustomControls$]="requiredCustomControls$">
  </app-information-details>

  <hr>

  <fieldset class="display-scope">
    <span class="title">
      {{ 'Channels' | translate }}
      <p class="caption grey">{{ 'Select which channels the deviation message will appear on' | translate }}</p>
    </span>
    <div class="form-group">
      <app-form-select-with-errors
        [label]="'Special publication'"
        [options$]="advancedOptions$"
        [control]="getterDisplayScope.advancedOptions"
        [id]="'advancedOptionsSelect'"
        [showValidation]="false">
      </app-form-select-with-errors>
    </div>
  </fieldset>

  <fieldset class="display-scope" formGroupName="displayScope">
    <div class="form-group flex-vertical-center">
      <div class="custom-checkbox">
        <input type="checkbox" formControlName="journeyPlanner" id="journeyPlanner" />
        <span class="focus-background"></span>
      </div>
      <label for="journeyPlanner">{{ 'SL.se and the journey planner' | translate }}</label>

      @if (getterDisplayScope.signDisplay.touched
        || getterDisplayScope.journeyPlanner.touched) {
        <app-validation-message
          [control]="trafficDeviationInformationGroup.controls.displayScope"
          >
        </app-validation-message>
      }
    </div>
  </fieldset>

  <fieldset class="display-scope screens" formGroupName="displayScope">
    <div class="form-group flex-vertical-center">
      <div class="custom-checkbox">
        <input type="checkbox" formControlName="signDisplay" id="signDisplay" />
        <span class="focus-background"></span>
      </div>
      <label for="signDisplay">{{ 'Stop displays, collection signs, and web displays' | translate }}</label>
    </div>
  </fieldset>

  @if (!isAtLeastOneRequiredValid) {
    <div class="display-scope validation-message-wrapper">
      <small>
        {{ 'At least one must be selected' | translate }}
      </small>
    </div>
  }

  <div class="publication-period-wrapper">
    <fieldset class="publication-period-toggler">
      <p class="title">
        {{ 'Publication time' | translate }}
      </p>
      <app-form-switch
        [checkboxValue]="togglePublicationPeriod.value"
        (toggleCallback)="togglePublicationPeriod.setValue($event)">
      </app-form-switch>

      <p class="caption grey">{{ "Specify a time for when the deviation information should be displayed" | translate}}</p>
    </fieldset>

    @if (togglePublicationPeriod.value && {value: (togglePublicationPeriod.valueChanges | async)}; as togglePublicationPeriodChanges) {
      <fieldset class="publication-period">
        <label class="label-above" for="publicationStartDate">
          {{ 'Start time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationInformationGroup.controls.publicationStartDate"
            [id]="'publicationStartDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>

        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationInformationGroup.controls.publicationStartTime"
            [id]="'publicationStartTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>

        @if (isPublicationFieldsSet()) {
          <app-validation-message [control]="_parentForm"></app-validation-message>
        }
      </fieldset>

      <fieldset>
        <label class="label-above" for="publicationEndDate">
          {{ 'End time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationInformationGroup.controls.publicationEndDate"
            [readonly]="true"
            [id]="'publicationEndDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>

        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationInformationGroup.controls.publicationEndTime"
            [readonly]="true"
            [id]="'publicationEndTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>
      </fieldset>
    }
  </div>
</ng-container>